const initialState = { appLoading: null, sessionId: null };
export default function reducer(state = initialState /* , action */) {
  return state;
}

export const selectors = {
  getSessionId(state) {
    return state.app.sessionId;
  },
  getFlags(state) {
    return {
      appLoading: state.app.appLoading,
      appLoadingFailed: state.app.appLoadingFailed,
      appLoadingError: state.app.error,
    };
  }
};
